import { Button, Form, Grid, Label, Segment, Table } from 'semantic-ui-react';
import styled from 'styled-components';

export const CustomRow = styled(Grid.Row)`
  flex-wrap: nowrap !important; /* Apply the desired flex-wrap value */
`;

export const StyledGrid = styled(Grid)`
 padding: 15px !important;
 background: white !important;
 .column-value {
  font-weight: bold !important;
 }
 `
export const StyledSegment = styled(Segment)`
background: white !important;
-webkit-box-shadow: none !important;
background-color: rgb(241 245 249) !important;
border: none !important;
margin-bottom: 2em !important;
border-radius: 1.3rem !important;
min-height: auto !important;
box-shadow: none !important;
padding-bottom: 15px !important;
 .column {
  -webkit-box-shadow: none !important;  
   box-shadow: none !important;
 }
 .header {
  font-size: 18px !important;
 }
 .row {
  flew-wrap: no-wrap !important;
 }
`
export const HeaderField = styled(Form.Field)`
 .header {
  font-size: 16px !important;
  font-weight: bold;
 }
 .column {
  padding-top: 0px !important;
  padding-bottom: 0px;
 }

 .left-column {
  width: 40% !important;
 }
 
 .row {
  padding-bottom: 0px !important;
  .ui.grid>.row {
    flex-wrap: no-wrap !important;
  }
 }
`
export const StyledButton = styled(Button)`
background: ${props => props.theme.firstColor};
color: white !important;
margin-bottom: 15px !important;
`
export const StyledField = styled(Form.Field)`
label {
  margin-bottom: 0px !important;
 }
 input {
  text-align: center !important;
 }
 .field {
  width: 100%;
 }
`
export const MilkProductionField = styled(Form.Field)`
display: flex;
flex-direction: column;
padding: 7px;
margin-top: 1em !important;
padding-left: 5px;
background-color: #e0f7fa;
border-left: 5px solid #7AB800 !important;
border-radius: 4px;
`;

export const SliderContainer = styled.div`
 label {
  color: black !important;
 }
`
export const StyledFirstColumn = styled.div`
display: flex;
flex-direction: column;
 .subHeader {
  font-size: 13px !important;
  font-weight: normal !important;
 }
`

export const StyledOtherMilkWrapper = styled.div`
margin-left: 20px;
 label {
  color: #5e6672 !important;
  font-weight: bold !important;
 }
margin-bottom: 1em;
`
export const StyledBillRow = styled(Grid.Row)`
padding-bottom: 5px !important;
align-items: center !important;
flex-wrap: no-wrap !important;
`
export const StyledTableCell = styled(Table.Cell)`
 .bold-cell {
    font-weight: bold !important;
    font-size: 15px !important;
}
`
export const StyledResultsFooter = styled.div`
display: flex;
justify-content: end;
font-size: 4px !important;
font-style: italic;
 > div {
   font-size: 13px !important;
 }
`

export const StyledLabelError = styled(Label)`
border: 1px solid #e0b4b4 !important;
color: #9f3a38 !important;
position: absolute !important;
margin-top: 0px !important;
background: #fff!important;
max-width: 300px;
`